import Dispatcher from '../dispatcher';
import resolvePromise from '../helper/resolved_promise';
import { RegoLookupActions } from '../constants/rego_lookup/rego_lookup_actions';
import RegoLookupAnalytics from '../../_modules/google_analytics/rego_lookup';

function showAction() {
    RegoLookupAnalytics.openAction();
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.SHOW_ACTION,
    });
}

function showActionV2(fromTyreSize) {
    RegoLookupAnalytics.openAction();
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.SHOW_ACTION_V2,
        payload: fromTyreSize,
    });
}

function showFromConfiguratorAction() {
    RegoLookupAnalytics.openFromConfiguratorAction();
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.SHOW_ACTION
    });
}

function hideAction() {
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.HIDE_ACTION,
    });

    return resolvePromise();
}

function closeRegoLookup() {
    RegoLookupAnalytics.closeAction();
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.HIDE_ACTION,
    });

    return resolvePromise();
}

function showConfirmationLayerAction() {
    RegoLookupAnalytics.showConfirmationLayer();
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.SHOW_CONFIRMATION_LAYER,
    });

    return resolvePromise();
}

function hideConfirmationLayerAction() {
    RegoLookupAnalytics.hideConfirmationLayer();
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.HIDE_CONFIRMATION_LAYER,
    });

    return resolvePromise();
}

function showVehicleNotProvidedLayerAction() {
    RegoLookupAnalytics.showVehicleNotProvidedLayer();
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.SHOW_VEHICLE_NOT_PROVIDED_LAYER,
    });

    return resolvePromise();
}

function hideVehicleNotProvidedLayerAction() {
    RegoLookupAnalytics.hideVehicleNotProvidedLayer();
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.HIDE_VEHICLE_NOT_PROVIDED_LAYER,
    });

    return resolvePromise();
}

function showPostcodeInvalidAction() {
    RegoLookupAnalytics.postcodeInvalid();
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.SHOW_POSTCODE_INVALID,
    });

    return resolvePromise();
}

function hidePostcodeInvalidAction() {
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.HIDE_POSTCODE_INVALID,
    });

    return resolvePromise();
}

function showRegistrationInvalidAction() {
    RegoLookupAnalytics.registrationInvalid();
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.SHOW_REGISTRATION_INVALID,
    });

    return resolvePromise();
}

function hideRegistrationInvalidAction() {
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.HIDE_REGISTRATION_INVALID,
    });

    return resolvePromise();
}

function setStateAction(state) {
    RegoLookupAnalytics.setStateAction(state);
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.SET_STATE,
        payload: state
    });

    return resolvePromise();
}

function setVehicleNotProvidedCommentAction(comment) {
    RegoLookupAnalytics.setVehicleNotProvidedCommentAction(comment);
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.SET_VEHICLE_NOT_PROVIDED_COMMENT,
        payload: comment
    });

    return resolvePromise();
}

function setPostcodeAction(postcode) {
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.SET_POSTCODE,
        payload: postcode
    });

    return resolvePromise();
}

function onPostcodeInputLeave(postcode) {
    RegoLookupAnalytics.setPostcodeAction(postcode);
    return resolvePromise();
}

function setRegistrationAction(registration) {
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.SET_REGISTRATION,
        payload: registration
    });

    return resolvePromise();
}

function onRegoInputLeave(registration) {
    RegoLookupAnalytics.setRegoAction(registration);
    return resolvePromise();
}

function setVehicleData(values) {
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.SET_VEHICLE_DATA,
        payload: values
    });

    return resolvePromise();
}

function setValuesAction(values) {
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.SET_VALUES,
        payload: values
    });

    return resolvePromise();
}

function resetValuesAction() {
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.RESET_VALUES,
    });

    return resolvePromise();
}

function showInputLayerAction() {
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.SHOW_INPUT_LAYER,
    });

    return resolvePromise();
}

function showLicenceNotFoundAction() {
    RegoLookupAnalytics.registrationNotFound();
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.SHOW_LICENCE_NOT_FOUND,
    });

    return resolvePromise();
}

function hideLicenceNotFoundAction() {
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.HIDE_LICENCE_NOT_FOUND,
    });

    return resolvePromise();
}

function disableButtonContinueAction() {
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.DISABLE_BUTTON_CONTINUE,
    });

    return resolvePromise();
}

function enableButtonContinueAction() {
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.ENABLE_BUTTON_CONTINUE,
    });

    return resolvePromise();
}

function disableButtonConfirmAction() {
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.DISABLE_BUTTON_CONFIRM,
    });

    return resolvePromise();
}

function enableButtonConfirmAction() {
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.ENABLE_BUTTON_CONFIRM,
    });

    return resolvePromise();
}

function showTyresAction() {
    RegoLookupAnalytics.showTyres();
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.SHOW_TYRES,
    });

    return resolvePromise();
}

function hideTyresAction() {
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.HIDE_TYRES,
    });

    return resolvePromise();
}

function setTyreAction(tyre) {
    RegoLookupAnalytics.setTyres(tyre);
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.SET_TYRE,
        payload: tyre
    });

    return resolvePromise();
}

function setTyreOptionsAction(tyres) {
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.SET_TYRE_OPTIONS,
        payload: tyres
    });

    return resolvePromise();
}

function showConfirmButtonAction() {
    RegoLookupAnalytics.showConfirmButton();
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.SHOW_CONFIRM_BUTTON,
    });

    return resolvePromise();
}

function submitRegoLookupForm() {
    RegoLookupAnalytics.submitRegoLookupForm();
}

function hideConfirmButtonAction() {
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.HIDE_CONFIRM_BUTTON,
    });

    return resolvePromise();
}

function setPostSuggestionRegoConfigurator(payload) {
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.SET_POSTCODE_SUGGESTION,
        payload
    });

    return resolvePromise();
}

function showInfoLayerAction() {
    RegoLookupAnalytics.showInfoAction();
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.SHOW_INFO_LAYER,
    });

    return resolvePromise();
}

function hideInfoLayerAction() {
    Dispatcher.handleRegoLookupAction({
        type: RegoLookupActions.HIDE_INFO_LAYER,
    });

    return resolvePromise();
}

export {
    showAction,
    showActionV2,
    hideAction,
    showConfirmationLayerAction,
    hideConfirmationLayerAction,
    showVehicleNotProvidedLayerAction,
    hideVehicleNotProvidedLayerAction,
    showPostcodeInvalidAction,
    hidePostcodeInvalidAction,
    setPostcodeAction,
    setRegistrationAction,
    setVehicleData,
    setValuesAction,
    resetValuesAction,
    showInputLayerAction,
    showLicenceNotFoundAction,
    hideLicenceNotFoundAction,
    disableButtonContinueAction,
    enableButtonContinueAction,
    disableButtonConfirmAction,
    enableButtonConfirmAction,
    setTyreAction,
    setTyreOptionsAction,
    showTyresAction,
    hideTyresAction,
    showConfirmButtonAction,
    hideConfirmButtonAction,
    setStateAction,
    setVehicleNotProvidedCommentAction,
    showRegistrationInvalidAction,
    hideRegistrationInvalidAction,
    setPostSuggestionRegoConfigurator,
    closeRegoLookup,
    showFromConfiguratorAction,
    onRegoInputLeave,
    onPostcodeInputLeave,
    submitRegoLookupForm,
    showInfoLayerAction,
    hideInfoLayerAction,
};
